module.exports = __webpack_public_path__ + "img/Sympa.9e8c6364.png";